import { useRouteError } from 'react-router-dom'
import { Seo } from '@/components/Seo'
import { Button } from '@/components/ui/Button'
import { useT, LocaleLink } from '@/i18n'

export function NotFoundPage() {
  const t = useT()
  const error = useRouteError() as { status?: number } | undefined
  return (
    <div className="mx-auto flex max-w-2xl flex-col items-center gap-6 px-4 py-24 text-center">
      <Seo title={t('system.notFound.seoTitle')} />
      <p className="font-gothic text-7xl text-blood-400">{error?.status ?? 404}</p>
      <h1 className="title-gothic text-2xl">{t('system.notFound.heading')}</h1>
      <p className="font-body text-bone-dim">{t('system.notFound.body')}</p>
      <LocaleLink to="/">
        <Button variant="blood">{t('system.notFound.returnCta')}</Button>
      </LocaleLink>
    </div>
  )
}

export default NotFoundPage
